import { PropsWithChildren, useState } from "react"
import PageTitleContext from "../context/PageTitleContext"

export default function PageTitleProvider(props: PropsWithChildren<{}>) {
    const [pageTitle, setPageTitle] = useState("UNISONO Alumni Club")
    return <PageTitleContext.Provider value={{pageTitle, setPageTitle}}>{props.children}</PageTitleContext.Provider>
}